module.exports = __webpack_public_path__ + "img/proapp-2.8614afc8.webp";